import dayjs from "dayjs";

/**
 * @description: console
 * @param {string} fileName
 * @param {string} info
 * @return {*}
 */
export const TConsole = (fileName: string, info: string): void => {
  console.log(formattedDate(), 'INFO', fileName, info)
}

/**
 * @description: debounce function
 * @param {T} func
 * @param {number} delay
 * @return {*}
 */
export const debounce = <T extends (...args: any[]) => any>(func: T, delay: number): Function => {
  let timerId: ReturnType<typeof setTimeout> | number |undefined;

  return function debounced(): void {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(func, delay);
  }
}

/**
 * @description: throttle function
 * @param {T} func
 * @param {number} delay
 * @return {*}
 */
export const throttle = <T extends (...args: any[]) => any, This>(func: T, delay: number): Function => {
  let lastExecTime = 0;
  let timerId: ReturnType<typeof setTimeout> | undefined;

  return function throttled(this: This, ...args: Parameters<T>): void {
    const now = Date.now();

    if (now - lastExecTime < delay) {
      if (timerId) {
        clearTimeout(timerId);
      }

      timerId = setTimeout(() => {
        lastExecTime = now;
        func.apply(this, args);
      }, delay);
    } else {
      lastExecTime = now;
      func.apply(this, args);
    }
  };
}

/**
 * @description: Remove emoji
 * @param {string} val
 * @return {string} String with emoji removed
 */
export const removeEmoji = (val: string):string =>  {
  let text = String(val)
  let reg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[9|E]\u3030|\uA9|\uAE|\u3030/gi
  console.log(reg.test(text), text.replace(reg, ''))
  return text.replace(reg, '')
}

/**
 * @description: Date formatting
 * @param {Date | string} date Date to be formatted, default today.
 * @param {string} format Formatting rules, default: YYYY-MM-DD
 * @return {Date}
 * @document：https://day.js.org/docs/en/display/format
 */
export const formattedDate = (date: Date | string = new Date(), format: string ='YYYY-MM-DD'): string => {
  return dayjs(date).format(format)
}
/**
 * @description: Filter Fuzzy Search on Select Dropdown
 * @param {String} input 
 * @param {string} option 
 * @return {Boolean}
 */
export const filterOption = (input: string, option?: { label: string; value: string | number }) => {
	return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
}

export function downloadFile(url: string, fileName: string) {
	fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
	  .then(res => res.blob())
	  .then(res => {
		const aElement = document.createElement('a');
		aElement.setAttribute('download', fileName);
		const href = URL.createObjectURL(res);
		aElement.href = href;
		aElement.setAttribute('target', '_blank');
		aElement.click();
		URL.revokeObjectURL(href);
	  });
  };